import React from "react";

/* ===================== STYLES ===================== */
import styles from "./SummaryCard.module.scss";

export default function SummaryCard({ icon, title, value }) {
  // Gracefully handle both legacy image URLs and modern lucide-react components
  const isStringIcon = typeof icon === "string";

  return (
    <div className={styles["admin-sum-card__container"]}>
      <div className={styles["admin-sum-card__icon-wrapper"]}>
        {isStringIcon ? (
          <img src={icon} alt={title} />
        ) : (
          icon // Renders lucide-react vector if passed directly
        )}
      </div>

      <div className={styles["admin-sum-card__content"]}>
        <p className={styles["admin-sum-card__title"]}>{title}</p>
        <h3 className={styles["admin-sum-card__value"]}>{value}</h3>
      </div>
    </div>
  );
}
